import _ from 'lodash';
import { SDLUtil, RequestUtil, StringUtil, DateUtil } from '@/utils';

const setGridData = ({ commit }, data) => {
  commit('SET_GRID_DATA_ACCKEY_EXCEPTION', data);
};

const setProjectList = ({ commit }, data) => {
  commit('SET_PROJECT_LIST_ACCKEY_EXCEPTION', data);
};
export default {
  async SEARCH_GRID_ACCKEY_EXCEPTION(store, param) {
    const searchPeriod = DateUtil.stdFormat(param.searchPeriod);
    param = { ...param, ...searchPeriod };
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/accesskey/exception/info-list?${StringUtil.queryStringfy(param)}`);

    if (!_.isEmpty(data)) {
      _.forEach(data.data.rows, item => {
        if (_.isEmpty(item.expiryDate)) item.expiryDate = '-';
      })
    }

    setGridData(store, data.data);
  },
  async SEARCH_PROJECT_LIST_ACCKEY_EXCEPTION(store, param) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/accesskey/exception/project?${StringUtil.queryStringfy(param)}`);

    setProjectList(store, data.data);
  },
  async UPDATE_EXCEPT_ACCKEY_EXCEPTION(store, param) {
    await RequestUtil.put(`${SDLUtil.API_URL}/accesskey/exception/key-except`, param);
  },
  async UPDATE_EXCEPT_ACCKEY_MAINTAIN(store, param) {
    await RequestUtil.put(`${SDLUtil.API_URL}/accesskey/exception/key-maintain`, param);
  },
};



// WEBPACK FOOTER //
// ./src/vuex/accKey/exception/accKeyExceptionAction.js